module.exports = __webpack_public_path__ + "images/program/package.2e61c0a4.svg";